import { forwardRef } from 'react';
import { IUserAvatarProps, UserAvatar } from '../user-avatar';
import { ContactHoverCardWidget } from '@sinups/ui-kit';
import { HoverCardProps } from '@mantine/core';

type UserAvatarWithCardProps = IUserAvatarProps & {
  hoverCardProps?: HoverCardProps;
};

export const UserAvatarWithCard = forwardRef<HTMLDivElement, UserAvatarWithCardProps>(
  ({ user, hoverCardProps = {}, ...props }, ref) => {
    return (
      <ContactHoverCardWidget
        id={user?.Id}
        name={user?.Name}
        email={user?.Email}
        hoverCardProps={hoverCardProps}
        fallbackSrc={props.src || ''}
      >
        <UserAvatar user={user} ref={ref} {...props} />
      </ContactHoverCardWidget>
    );
  }
);

UserAvatarWithCard.displayName = 'UserAvatarWithCard';
